import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ComboService, ActualCuttingService } from "../../../services/index";
import { cuttingDcPrint } from "./cuttingDcPrint";

declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./cuttingStore.html"
})
export class cuttingStoreComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  designnoList = [];
  gridOptions: any;
  dataList = [];
  selected = [];
  data = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  cuttingDcStatusList = ["YES", "NO"];
  frontDcStatusList = ["YES","NO"];
  frontStoreList = ["Return From Front"];
  filter = {
    wo_no: "",
    cutting_dc_status: "NO",
    front_dc_status: "NO",
    front_rt_store: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc"
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("detailsTemplate") detailsTemplate;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("pageTemplate") pageTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private acService: ActualCuttingService,
    private modalService: BsModalService,
    private comboservice: ComboService,
    public toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.getColumns();
    // this.getDesignNoList();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
      if (this.menu.param == 'store_to_front') {
        this.columns = [
          {
            name: "SNo",
            prop: "sno",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
            headerClass: "text-center",
            sortable: false,
            cellTemplate: this.snoTemplate,
            toggle: true,
            cellClass: "text-center"
          },
          {
            name: "Date",
            prop: "front_issue_date",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 100,
            maxWidth: 100,
            width: 100
          },
          {
            name: "WO No",
            prop: "wo_no",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80
          },
          {
            name: "Status",
            prop: "act_status",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120,
          },
          {
            name: "Action",
            prop: "sno",
            minWidth: 100,
            maxWidth: 120,
            width: 110,
            sortable: false,
            cellTemplate: this.editDeleteTemplate,
            headerClass: "text-center",
            cellClass: "text-center"
          }
        ];



      } else {
        this.columns = [
          {
            name: "SNo",
            prop: "sno",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
            headerClass: "text-center",
            sortable: false,
            cellTemplate: this.snoTemplate,
            toggle: true,
            cellClass: "text-center"
          },
          {
            name: "Date",
            prop: "store_issue_date",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 100,
            maxWidth: 100,
            width: 100
          },
          {
            name: "WO No",
            prop: "wo_no",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80
          },
          {
            name: "Status",
            prop: "act_status",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120
          },
          {
            name: "Action",
            prop: "sno",
            minWidth: 100,
            maxWidth: 120,
            width: 110,
            sortable: false,
            cellTemplate: this.editDeleteTemplate,
            headerClass: "text-center",
            cellClass: "text-center"
          }
        ];
      }
      if(this.menu.param == 'store_to_front'){
        if (this.filter.front_dc_status == "NO") {
          let select = {
            prop: "selected",
            name: "",
            sortable: false,
            canAutoResize: false,
            draggable: false,
            resizable: false,
            headerCheckboxable: false,
            checkboxable: true,
            width: 30,
          };
          this.columns.splice(0, 0, select);
        }
        else if (this.filter.front_rt_store == "Return From Front" && this.filter.front_dc_status == "YES") {
          let front_store = {
            name: "Return Status",
            prop: "return_status",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 150,
            maxWidth: 150,
            width: 150
          }
          this.columns.splice(5, 0, front_store)
        }
        else if (this.filter.front_dc_status == "YES") {
          let front_dcprint = {
            name: "FRONTDC Print",
            prop: "front_dcprint",
            minWidth: 150,
            maxWidth: 150,
            width: 150,
            cellClass: "text-center",
            sortable: false,
            cellTemplate: this.detailsTemplate,
          };
          this.columns.splice(5,0,front_dcprint)
          
            let front_dc_no = {
            name: "FRONT.DC.NO",
            prop: "front_dc_no",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 150,
            maxWidth: 150,
            width: 150,
          }
          this.columns.splice(1,0,front_dc_no)
        }
        else {
          let column = this.columns.filter(function (obj) {
            return obj.prop !== "selected";
          });
          this.columns = column;
        }
      } else {
      if (this.filter.cutting_dc_status == "NO") {
        let select = {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: false,
          checkboxable: true,
          width: 30,
        };
        this.columns.splice(0, 0, select);
      }
      else if (this.filter.cutting_dc_status == "YES") {
        let cutting_dcprint = {
          name: "CuttingDC Print",
          prop: "cutting_dcprint",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          cellClass: "text-center",
          sortable: false,
          cellTemplate: this.detailsTemplate,
        };
        this.columns.splice(5,0,cutting_dcprint)
        
          let cutting_dc_no = {
          name: "CUTTING.DC.NO",
          prop: "cutting_dc_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        }
        this.columns.splice(1,0,cutting_dc_no)
      }
      else {
        let column = this.columns.filter(function (obj) {
          return obj.prop !== "selected";
        });
        this.columns = column;
      }
    }
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }
  // getDesignNoList() {
  //   let params = {};
  //   this.comboservice.getDesignCombo(params).then((res: any) => {
  //     this.designnoList = res;
  //   });
  // }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  clearFilter(): void {
    this.filter.wo_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getColumns();
    // this.getOrderList();
  }
  onSelect({ selected }) {
    this.selected = [];
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if(this.menu.param == 'store_to_front') {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            //  tabParent: 'Transaction',
            tabName: "ADD STORE TO FRONT",
            title: "ADD STORE TO FRONT",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "STORE TO FRONT"
          }
        };
      } else if (mode == "Edit") {
        tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "EDIT STORE TO FRONT",
            title: "EDIT STORE TO FRONT",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "EDIT STORE TO FRONT"
          }
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "VIEW STORE TO FRONT",
            title: "VIEW STORE TO FRONT",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "VIEW STORE TO FRONT"
          }
        };
      }
    } else {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            //  tabParent: 'Transaction',
            tabName: "ADD CUTTING STORE",
            title: "ADD CUTTING STORE",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "ADD CUTTING STORE"
          }
        };
      } else if (mode == "Edit") {
        tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "EDIT CUTTING STORE",
            title: "EDIT CUTTING STORE",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "EDIT CUTTING STORE"
          }
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            //   tabParent: 'Transaction',
            tabName: "VIEW CUTTING STORE",
            title: "VIEW CUTTING STORE",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "VIEW CUTTING STORE"
          }
        };
      }
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  bsModalRef: BsModalRef;

  getOrderList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_no: this.filter.wo_no,
      dc_status : this.filter.cutting_dc_status,
      front_status : this.filter.front_dc_status,
      front_return_status : this.filter.front_rt_store,
    };
    params['flag'] = '';
    if(this.menu.param == 'store_to_front') {
      params['flag'] = this.menu.param;
    }
    let that = this;
    this.isLoadMask = this.acService
      .getCuttingStoreList(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  onSubmitMergeDC() {
    if (this.selected.length > 0) {
      let obj = {
        ac_id: "",
        cutting_dc_status:"",
      };
      this.selected.forEach((el) => {
        obj = {
          ac_id: el.ac_id,
          cutting_dc_status: "YES",
        };
        this.data.push(obj);
      });
      this.approveCuttingDc();
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
  onSubmitMergeFrontDC() {
    if (this.selected.length > 0) {
      let obj = {
        ac_id: "",
        front_dc_status:"",
      };
      this.selected.forEach((el) => {
        obj = {
          ac_id: el.ac_id,
          front_dc_status: "YES",
        };
        this.data.push(obj);
      });
      this.approveFrontDc();
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
  approveFrontDc() {
    let that = this;
    swal({
      title: "Are you sure to Approve these FRONT DC.NO?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        let params = {
          selectedList: JSON.stringify(that.data),
        };
          that.isLoadMask = that.acService
            .approveFrontDc(params)
            .then((res: any) => {
              if (res.success) {
                swal(
                  "FRONT DC Approved Successfully and FRONT DC No " +
                    res.front_dc_no +
                    " was generated"
                );
                that.data = [];
              }
              if (res.success) {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
            });
      },
      function (dismiss) {}
    );
  }
  approveCuttingDc() {
    let that = this;
    swal({
      title: "Are you sure to Approve these CUTTING DC.NO?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        let params = {
          selectedList: JSON.stringify(that.data),
        };
          that.isLoadMask = that.acService
            .approveCuttingDc(params)
            .then((res: any) => {
              if (res.success) {
                swal(
                  "CUTTING DC Approved Successfully and  CUTTING DC No " +
                    res.cutting_dc_no +
                    " was generated"
                );
                that.data = [];
              }
              if (res.success) {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
            });
      },
      function (dismiss) {}
    );
  }
  print(row) {
      row.page_type = this.menu.open_type
    // console.log(row,"chek from print")
    this.bsModalRef = this.modalService.show(cuttingDcPrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/cuttingStore/cuttingStore.ts